import axios from "axios"

const customAxios = axios.create({
  baseURL: process.env.REACT_APP_HOST
})

console.log(process.env.REACT_APP_HOST)

customAxios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear()
      //dispatch algun codigo de error para que me salga en el login
      //redireccionar al login la seccion ha caducado
      if (window.location.hostname == 'localhost') {
        location.href = `http://${window.location.hostname}:3000/auth/not-auth`
      } else {
        location.href = `http://${window.location.hostname}/auth/not-auth`
      }
    }
    console.log(error)
    return error
  }
)

const token = JSON.parse(localStorage.getItem("accessToken"))

if (token) {
  customAxios.defaults.headers.common["Authorization"] = `Bearer ${token}`
}

customAxios.defaults.headers.post["SISTEMA"] = ["Web"]

export default customAxios

